// extracted by css-extract-rspack-plugin
export default {"container":"_1c3d54f9","title":"_fd464dde"};